import { v4 as uuidv4 } from "uuid";
export class EntryActionSaveModel {
    constructor() {
        this.id = uuidv4();
        this.entryId = "";
        this.description = "";
        this.actionDateAsString = "";
    }
}
export default class EntryAction extends EntryActionSaveModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
